import DoAction from "./DoAction";
import store from '@r/store';

export default class DoAddRemoveObject extends DoAction {
    constructor(object, add_remove, parent, info) {
        super();

        this.object = object;
        this.parent = parent ? parent : object.parent;
        this.add_remove = add_remove === undefined ? true : add_remove;

        if (info) {
            this.defaultLocationBefore = info.defaultLocationBefore;
            this.defaultLocationAfter = info.defaultLocationAfter;
        }
    }
	redo() {
		if (this.add_remove) this.addObject();
		else this.removeObject();
	}
	undo() {
		if (this.add_remove) this.removeObject();
		else this.addObject();
    }
    addObject() {
        // refered from addItemToScene() in ItemsModal.jsx
        this.parent.add(this.object);
        if (this.parent.isMountPlane && this.defaultLocationBefore) {
            // this.scene.addObjectDirectly(this.object);
            this.scene.setDefaultLocation(this.add_remove ? this.defaultLocationAfter : this.defaultLocationBefore);
        }
        this.viewer.renderOnDemand.set();
    }
    removeObject() {
        // refered from deleteCabinet() in CabinetMenu.tsx
        const viewer = this.viewer;
        let sels = this.selectedObject;
        if (0 < sels.length && sels.includes(this.object)) {
            // deselect
            sels.length = 0;
            viewer.transformControls && viewer.transformControls.detach();

            store.dispatch({
              type: 'SET_RIGHT_SIDE_CABINET_MENU_MODE',
              value: 'addCabinet'
            });
        }
        this.parent.remove(this.object);
        if (this.parent.isMountPlane && this.defaultLocationBefore) {
            // this.scene.addObjectDirectly(this.object);
            this.scene.setDefaultLocation(this.add_remove ? this.defaultLocationBefore : this.defaultLocationAfter);
        }
        viewer.renderOnDemand.set();
    }
}